import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { Scale } from "lucide-react";

interface JudgmentReference {
  id: string;
  målnummer: string;
  domstol: string;
  instans: string;
  dom_datum: string;
  parter: string;
}

interface ReferencedJudgmentsProps {
  judgments: JudgmentReference[];
}

export function ReferencedJudgments({ judgments }: ReferencedJudgmentsProps) {
  const navigate = useNavigate();

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 mb-3">
        <Scale className="h-4 w-4" />
        <h3 className="font-semibold text-sm">Refererade avgöranden</h3>
        <span className="text-xs text-muted-foreground">({judgments.length})</span>
      </div>

      {judgments.map((judgment) => (
        <Card
          key={judgment.id}
          className="cursor-pointer transition-colors group hover:bg-primary"
          onClick={() => navigate(`/avgorande/${judgment.id}`)}
        >
          <CardHeader className="p-3 pb-2">
            <CardTitle className="text-sm font-medium text-foreground group-hover:text-white">
              {judgment.målnummer}
            </CardTitle>
          </CardHeader>
          <CardContent className="p-3 pt-0 space-y-1">
            <p className="text-xs text-muted-foreground group-hover:text-white/90">
              <span className="font-medium">Domstol:</span> {judgment.domstol}
            </p>
            <p className="text-xs text-muted-foreground group-hover:text-white/90">
              <span className="font-medium">Instans:</span> {judgment.instans}
            </p>
            <p className="text-xs text-muted-foreground group-hover:text-white/90">
              <span className="font-medium">Datum:</span>{" "}
              {new Date(judgment.dom_datum).toLocaleDateString('sv-SE')}
            </p>
            <p className="text-xs text-muted-foreground group-hover:text-white/90 line-clamp-2">
              <span className="font-medium">Parter:</span> {judgment.parter}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
